import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectCustomEvent } from '@ionic/core';
import { BehaviorSubject } from 'rxjs';

import { ReactiveControlComponent } from 'src/app/components/shared/reactive-control.component';
import { DeliveryType, MealDeliveryAreaTiming } from 'src/app/models';
import { MealDeliveryTimingPipe } from 'src/app/pipes/meal-delivery-timing-pipe/meal-delivery-timing.pipe';

interface DisplayTiming extends MealDeliveryAreaTiming {
  displayTime: string;
}

@Component({
  selector: 'pos-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TimePickerComponent)
    }
  ]
})
export class TimePickerComponent
  extends ReactiveControlComponent<number>
  implements OnChanges
{
  @Input() showAsapOption = true;
  @Input() timings: MealDeliveryAreaTiming[];
  @Input() deliveryType: DeliveryType;

  private readonly displayTimingsSubject = new BehaviorSubject<DisplayTiming[]>(
    []
  );
  readonly displayTimings$ = this.displayTimingsSubject.asObservable();
  private set displayTimings(value: DisplayTiming[]) {
    this.displayTimingsSubject.next(value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { timings, deliveryType } = changes;
    if (timings || deliveryType) {
      this.updateDisplayTimings();
    }
  }

  onSelectChange(ev: Event) {
    this.value = (ev as SelectCustomEvent<number>).detail.value;
  }

  private updateDisplayTimings() {
    if (this.timings && this.deliveryType) {
      this.displayTimings = this.timings.map((timing) => ({
        ...timing,
        displayTime: MealDeliveryTimingPipe.formatTime(
          timing,
          this.deliveryType
        )
      }));
    }
  }
}
